module.exports = __webpack_public_path__ + "img/index1.33800ece.png";